import useInitImg from '@/hooks/useInitImg';
import RootLayout from '@/component/wing/Layout';
import useScreenWidthBelowThreshold from '@/hooks/useScreenWidthBelowThreshold';
import styles from './index.module.scss';
import styles_mobile from './index_mobile.module.scss';
import OneLinkImg from '@/component/wing/OneLinkImg';
import Link from 'next/link';
import cx from 'classnames';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import WingLoginModal from '@/component/playgroundMobile/localPlayground/WingLoginModal';
import { isWingLocalLoggedIn } from '@/component/playgroundMobile/localPlayground/storage';

const backgroundArr = [
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkIyUjZTR1QyUkNQNzdMWE1DMlhMQklHV1dZQlMyWSIsInciOjI4ODAsImgiOjE3OTYsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxOTY1NTY1NDA2OTc0OTUzNX0?format=originalOFGHLERTH',
];
const backgroundArrMobile = [
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkZYUEJXRlBYUDNMMlBKVlNXT0hNSzJQWVJXSEJLSSIsInciOjc1MCwiaCI6MTQzNiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEwMTMxNTIwNDQxNjI0OTY2NzQ3fQ?format=originalOFGHLERTH',
];

export const WingHome = ({ showLoginEntry = false }: { showLoginEntry?: boolean }) => {
  useInitImg([...backgroundArr, ...backgroundArrMobile]);
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(700);
  const router = useRouter();
  const [showWingLogin, setShowWingLogin] = useState(false);
  const [wingLogged, setWingLogged] = useState(false);

  useEffect(() => {
    if (showLoginEntry) {
      setWingLogged(isWingLocalLoggedIn());
    }
  }, [showLoginEntry, showWingLogin]);

  const handleLoginClick = () => {
    if (isWingLocalLoggedIn()) {
      router.push('/playground');
      return;
    }
    setShowWingLogin(true);
  };

  const loginEntry = showLoginEntry ? (
    <button type="button" className={styles.loginButton} onClick={handleLoginClick}>
      {wingLogged ? 'Play' : 'Login'}
    </button>
  ) : null;

  const loginModal = showWingLogin ? (
    <WingLoginModal
      onClose={() => setShowWingLogin(false)}
      onSuccess={() => {
        setShowWingLogin(false);
        setWingLogged(true);
        router.push('/playground');
      }}
    />
  ) : null;

  if (isScreenWidthBelow700px) {
    return (
      <div className={styles_mobile.wrapper} style={{ backgroundImage: `url(${backgroundArrMobile[0]})` }}>
        {showLoginEntry ? (
          <button type="button" className={styles_mobile.loginButton} onClick={handleLoginClick}>
            {wingLogged ? 'Play' : 'Login'}
          </button>
        ) : null}
        <OneLinkImg
          className={styles_mobile.img}
          src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlZUREhSV1M3VTZBSVJVUE9RMk5WUVZEU0hPUTRaNyIsInciOjQ3MCwiaCI6MTEyLCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MTU5MTQ4MzkzNjk4MDkwNTkwMzZ9"
        />
        <div className={styles_mobile.footer}>
          <div className={styles_mobile.terms}>
            <Link href="/wing/privacy" target="_blank">
              Privacy
            </Link>
            <span className={styles_mobile.divider}>|</span>
            <Link href="/wing/terms" target="_blank">
              Terms
            </Link>
          </div>
          <div className={cx(styles_mobile.footerText, styles_mobile.text)}>
            Copyright © 2026 WINK TECHNOLOGY PTE. <br />
            LTD All Rights Reserved.
          </div>
        </div>
        {loginModal}
      </div>
    );
  }

  return (
    <RootLayout className={styles.wrapper} headerExtra={loginEntry}>
      <div className={styles.container}>
        <div>
          <div className={styles.content} />
          <div className={styles.button}>
            <OneLinkImg src="https://cdn.duetapp.net/v1/images/eyJpZCI6IjY3TTRRN0ZRNEg0VkFSUktXU1ZUS09FUExUNTVWSiIsInciOjQ0NiwiaCI6MTIwLCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MTI3NzM1MDM2MTAwNzA3ODR9" />
            <OneLinkImg src="https://cdn.duetapp.net/v1/images/eyJpZCI6Ik1RRDNHWkc1VDQzUk02RzRWRk5ZQUg1NFg3NUlFUSIsInciOjQ0NiwiaCI6MTIwLCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MjU5NjI5OTY1MjY2MTM1MDR9" />
          </div>
        </div>
        <div className={styles.pic} />
      </div>
      {loginModal}
    </RootLayout>
  );
};

export default function WingHomePage({ showLoginEntry = false }: { showLoginEntry?: boolean }) {
  return <WingHome showLoginEntry={showLoginEntry} />;
}

export async function getServerSideProps(context) {
  const host = context.req?.headers?.host || '';
  const showLoginEntry = host.includes('wingapp.ai') || host.includes('localhost');

  return {
    props: {
      showLoginEntry,
    },
  };
}
